import React from "react";

const NewNotificationIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    width="6"
    height="6"
    viewBox="0 0 6 6"
    fill="none"
    {...props}
  >
    <circle cx="3" cy="3" r="3" fill="#FF0000" />
  </svg>
);

export default NewNotificationIcon;
